import { apiClient } from './axiosClient';

export interface TriggerJobResponse {
  success: boolean;
  message: string;
}

export interface TriggerPotStatusTransitionsResponse {
  success: boolean;
  message: string;
}

/**
 * Jobs API
 *
 * API functions for triggering development jobs
 */
export const jobsApi = {
  /**
   * Trigger pot status transitions job
   * Requires developer.jobs.pot-transition.trigger permission
   */
  triggerPotStatusTransitions:
    async (): Promise<TriggerPotStatusTransitionsResponse> => {
      const response =
        await apiClient.post<TriggerPotStatusTransitionsResponse>(
          '/api/dev/jobs/pot-status-transitions'
        );
      return response.data;
    },

  processNotificationDefinitions: async (): Promise<TriggerJobResponse> => {
    const response = await apiClient.post<TriggerJobResponse>(
      '/api/dev/notifications/process-definitions'
    );
    return response.data;
  },

  processPushNotifications: async (): Promise<TriggerJobResponse> => {
    const response = await apiClient.post<TriggerJobResponse>(
      '/api/dev/notifications/process-push'
    );
    return response.data;
  },

  triggerInvoiceGeneration: async (): Promise<TriggerJobResponse> => {
    const response = await apiClient.post<TriggerJobResponse>(
      '/api/dev/jobs/invoice-generation'
    );
    return response.data;
  },
};
